<template lang="html">
  <article class="gallery">
    <ul class="gallery__filter" v-show="false">
      <li class="gallery__filterItem filter" :class="filter.selected ? 'selected' : ''" v-for="(filter, i) in filters"
        @click="selectFilter" :key="i">{{ filter.label }}</li>
    </ul>
    <div class="gallery__list" :class="type === 'video' ? 'gallery__list--video' : ''">
      <WorkItem v-for="item in items" :id="item.id" :image="item.image" :label="item.label" :tag="item.tag"
        :key="item.id" :type="type" />
    </div>
  </article>
</template>

<script>
import anime from 'animejs';
import WorkItem from './WorkItem.vue';

export default {
  name: 'Gallery',
  props: ['type', 'items'],
  components: {
    WorkItem
  },
  updated() {
    anime({
      targets: '.gallery__filterItem',
      opacity: [0, 1],
      duration: 1000,
      easing: 'easeInOutCubic',
      delay: function (el, i) {
        return 300 * i + 2000;
      }
    });
    anime({
      targets: '.workItem',
      opacity: [0, 1],
      translateY: ["20px", 0],
      translateZ: 0,
      duration: 1000,
      easing: 'easeInOutCubic',
      delay: function (el, i) {
        return 300 * i + 2200;
      }
    });
  },
  data() {
    return {
      filters: [
        {
          label: 'Show All',
          selected: true
        },
        {
          label: 'Commercial',
          selected: false
        },
        {
          label: 'Long Form',
          selected: false
        }
      ]
    }
  },
  methods: {
    selectFilter(event) {
      const target = event.target;
      const index = [...target.parentElement.children].indexOf(target);
      this.filters.forEach((filter, i) => {
        i === index ? filter.selected = true : filter.selected = false;
      });
    }
  }
}
</script>

<style lang="scss">
@import "../styles/config.scss";

.gallery {
  &__filter {
    margin: 40px auto;
    max-width: 1000px;

    li+li {
      margin-left: 20px;
    }
  }

  &__filterItem {
    font-family: CamptonBold;
    font-size: 22px;
    color: var(--Neu01);
    display: inline-block;
    border-radius: 20px;
    padding: 5px 25px;
    border: 2px solid transparent;
    transition: border-color .2s ease-in;

    &.selected {
      border-color: var(--M01);
    }
  }

  &__list {
    margin-top: 100px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-row-gap: 40px;
    grid-column-gap: 60px;

    // &--video {
    //   grid-template-columns: repeat(2, 1fr);
    // }
  }


  @include mq(0, 1024px) {
    &__list {
      grid-row-gap: 20px;
      grid-column-gap: 40px;
    }
  }

  @include mq(0, 768px) {
    &__filter {
      margin: 40px 0;

      li+li {
        margin-left: 10px;
      }
    }

    &__filterItem {
      font-size: 18px;
      padding: 5px 15px;
    }

    &__list {
      margin-top: 40px;
      grid-template-columns: repeat(2, 1fr);
      grid-row-gap: 20px;
      grid-column-gap: 40px;
    }
  }

  @include mq(0, 512px) {
    &__filter {
      margin: 20px 0;
      width: 200px;

      li+li {
        margin-left: 0;
      }
    }

    &__filterItem {
      margin: 5px 0;
    }

    &__list {
      grid-template-columns: repeat(1, 1fr);
      grid-row-gap: 20px;
      grid-column-gap: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Gallery.vue